// ReactJs
import React from 'react'
import { useNavigate } from 'react-router'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '@shared/utils/theme'
import Button from '../../components/Button'

const WelcomePageLogoutContainer = styled.div`
  margin-top: 36px;
  margin-left: 20px;
  margin-bottom: 100px;

  .logout-btn {
    background: ${ theme.palette.white };
    color: ${ theme.palette.blue };
    border: 1px solid ${ theme.palette.blue };
  }

`

export default function WelcomePageLogout({ ...props }) {
  const navigate = useNavigate()

  const logout = () => {
      navigate('/logout')
  }

  return (
    <WelcomePageLogoutContainer>
      <Button className="logout-btn" onClick={ logout } >
        Se déconnecter
      </Button>
    </WelcomePageLogoutContainer>
  )
}
